/**
 * Every row in an ask-user card is this shell (Figma "User Input Option").
 * Keeping it in one place is what makes an option, the "Other…" row and a
 * settled answer read as one family and line up with each other.
 */
export const OPTION_ROW =
  'text-foreground flex w-full items-start gap-2 rounded-lg border p-2 text-left transition-[border-color,background-color] duration-150 ease-out cursor-pointer'

/**
 * Press feedback for the rows that are buttons — scale only, and only when
 * motion is welcome. Rows holding a text box stay still.
 */
export const OPTION_ROW_PRESSABLE =
  'motion-safe:transition-[border-color,background-color,transform] motion-safe:active:scale-[0.98]'

/**
 * The surface every row sits on. Explicit because this app disables Tailwind's
 * preflight, so a bare `<button>` keeps the UA `buttonface` grey and the row
 * reads as a pressed control rather than a card.
 */
export const OPTION_ROW_SURFACE = 'bg-background'

/** Row is up for grabs. */
export const OPTION_ROW_IDLE = `${OPTION_ROW_SURFACE} border-border hover:border-hover`

/** The "Other…" row before it holds an answer. */
export const OPTION_ROW_DASHED = `${OPTION_ROW_SURFACE} border-border hover:border-hover border-dashed`

/**
 * Optional staggered entrance, used only by the `feedback` variant — see
 * `staggerRows` in `theme.ts` for why the `input` card renders at rest.
 * `fill-mode-both` keeps a row invisible until its delay starts. Fade survives
 * reduced motion; the rise does not.
 */
export const ROW_STAGGER = 'animate-in fade-in motion-safe:slide-in-from-bottom-1 fill-mode-both duration-200'
const STAGGER_STEP_MS = 40

export function staggerDelay(index: number): { animationDelay: string } {
  return { animationDelay: `${index * STAGGER_STEP_MS}ms` }
}
